import { Grid } from '@mui/material';
import React from 'react';
import Scales from '@Components/Utils/icons/Scales';
import { useGlobalization } from '@Translations/useGlobalization';
import { Text } from '@innovyze/stylovyze';

export const NoParameters = () => {
	const { t } = useGlobalization();

	return (
		<Grid container>
			<Grid
				container
				item
				xs={12}
				justifyContent="center"
				style={{ paddingTop: '40px' }}>
				<Scales />
			</Grid>
			<Grid container item xs={12} justifyContent="center">
				<Text variant="heading-medium-strong">
					{t('You do not have both parameters configured.')}
				</Text>
			</Grid>
			<Grid container item xs={12} justifyContent="center">
				<Text variant="caption-medium">
					{t(
						'Configure Parameter 1 and Parameter 2 to set up scores.',
					)}
				</Text>
			</Grid>
		</Grid>
	);
};
